import React from 'react';
import PropTypes from 'prop-types';

import { StyledHorizontalRule } from './style';

export const HorizontalRule = (props) => {
    const { $color, ...rest } = props;
    return <StyledHorizontalRule $color={$color} {...rest}></StyledHorizontalRule>;
};

HorizontalRule.propTypes = {
    $color: PropTypes.string,
};
